import React from 'react';
import { graphql, Link } from 'gatsby';
import Layout from '../components/Layout';
import { ContactForm } from '../views/contact-form';

import { RichTextArticle } from '../components/rich-text-article';

export default ({ data, pageContext }) => {
  const { post } = data;
  const { title, body, tags } = post;

  return (
    <Layout title={title}>
      <section className="section">
        <div className="container">
          <h1 className="title is-1 has-text-centered">{title}</h1>

          <RichTextArticle body={body} />

          <div className="tags are-medium">
            {tags.map((tag) => (
              <Link to={`/blog/tag/${tag.slug}`} className="tag">
                {tag.title}
              </Link>
            ))}
          </div>
          <ContactForm />
        </div>
      </section>
    </Layout>
  );
};

/**
 * id — id статьи
 * assets — id ассетов из статьи
 */
export const blogPostQuery = graphql`
  query blogPostQuery($id: String!, $assetsIds: [String!]!) {
    post: contentfulBlogPost(id: { eq: $id }) {
      title
      body {
        json
      }
      tags {
        title
        slug
      }
    }

    assets: allContentfulAsset(filter: { contentful_id: { in: $assetsIds } }) {
      edges {
        node {
          localFile {
            childImageSharp {
              fluid(maxWidth: 500) {
                srcSet
              }
            }
          }
        }
      }
    }
  }
`;
